/* eslint-disable react/sort-comp */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable jsx-a11y/alt-text */
import React from 'react';

import {isNaN} from 'lodash';
import {connect} from 'react-redux';
import {createFilter} from 'react-search-input';

import {showKeyboard, showPopUp, hidePopUp} from '@/actions/modalActions';
import * as setupActions from '@/actions/setupActions';
import {Get, Delete} from '@/api/request';
import HelpIcon from '@/assets/icons/Question.svg';
import DELETE_ICON from '@/assets/icons/Remove.svg';
import EDIT_ICON from '@/assets/icons/Rename.svg';
import SEARCH_ICON_BLACK from '@/assets/icons/si-glyph-zoom-in-black.svg';
import AdvSetup from '@/components/advancedSetupThumb/AdvSetup';
import PopUpWizard from '@/components/popup/PopUpWizard';
import {MembraneTypeOptions} from '@/constants/autoProfileEnum';
import {FIELD_NAME_PRESSURE} from '@/constants/enums';
import * as APPDATA from '@/constants/pcConstAppData';
import {createNewJsonObject, IsEmpty} from '@/libs/appHelper';
import {membraneTypeConverter} from '@/libs/autoProfileHelper';

import {
  DataHelpHome,
  DataHelpConcentrate,
  DataHelpConcentrateMoreThan50,
  DataHelpBufferDiscrete,
  DataHelpBufferContinuous,
  DataHelpAdvancedSetup,
  DataHelpManualControl,
  DataHelpStatusAndGraph,
  DataHelpRecovery,
  // nextPage,
} from '../autoProfile/help/AutoProfileHelp';
import {MEMBRANE_CUT_OFF} from '../systemSetting/pressureSetting/pressureSettingConstant';

import './AdvancedSetupExplorer.less';

const SEARCH_ADV_SETUP = 'SEARCH';
const EDIT_ADV_SETUP = 'EDIT';
const DELETE_ADV_SETUP = 'DELETE';

const KEYS_TO_FILTERS = ['Name'];

@connect((store) => ({
  //--------------------------------------------------------------------
  advSetupList: store.setupStore.advSetupList,
  // currentAdvSetup: store.setupStore.currentAdvSetup,
  advSetupSelected: store.setupStore.advSetupSelected,
  showAdvSetup: store.setupStore.showAdvSetup,
  updateAdvSetupList: store.setupStore.updateAdvSetupList,
  resetPreviewAdvSetup: store.setupStore.resetPreviewAdvSetup,
  advSetupSettingExplorer: store.setupStore.advSetupSettingExplorer,
  lastAdvSetupIdView: store.setupStore.lastAdvSetupIdView,
  templateNewAdvSetup: store.setupStore.templateNewAdvSetup,
  fontSize: store.setupStore.fontSize,
  activeMenu: store.setupStore.activeMenu,
  advSetupChoosen: store.setupStore.advSetupChoosen,
  isPCRunning: store.setupStore.isPCRunning,
  modifyAdvSetup: store.setupStore.modifyAdvSetup,
  editAdvSetup: store.setupStore.editAdvSetup,
  // idAdvSetup: store.setupStore.advSetupSelected ? store.setupStore.advSetupSelected[APPDATA.KEY.Id]:undefined,
  currentAdvSetupParams: store.setupStore.currentAdvSetupParams,
  defaultConfigAdvSetupParams: store.setupStore.defaultConfigAdvSetupParams,
  membraneCutOffSize: store.setupStore.currentProfileParams[APPDATA.KEY.MembraneCutOffSize],
  membraneType: store.setupStore.currentProfileParams[APPDATA.KEY.MembraneType],
  defaultReturnValvePressure: store.setupStore.defaultReturnValvePressure,
  modeHelp: store.setupStore.modeHelp,
  currentProfileParams: store.setupStore.currentProfileParams,
}))
class AdvancedSetupExplorer extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.handleClickSetup = this.handleClickSetup.bind(this);
    // this.onClick = this.onClick.bind(this);
    this.closePopUp = this.closePopUp.bind(this);
    this.onClickPopUpDelete = this.onClickPopUpDelete.bind(this);
    // this.onChange = this.onChange.bind(this);
    // Initiate state for this component
    this.state = {
      advSetupName: '',
      searchText: undefined,
      ReturnValvePressure: {
        [MEMBRANE_CUT_OFF.CHIP_3_KDA]: '',
        [MEMBRANE_CUT_OFF.CHIP_5_KDA]: '',
        [MEMBRANE_CUT_OFF.CHIP_10_KDA]: '20',
        [MEMBRANE_CUT_OFF.CHIP_30_KDA]: '15',
        [MEMBRANE_CUT_OFF.CHIP_50_KDA]: '10',
        [MEMBRANE_CUT_OFF.CHIP_100_KDA]: '',
        [MEMBRANE_CUT_OFF.CHIP_300_KDA]: '',
      },
      isHelpModeEnable: false,
      contentHelp: DataHelpHome,
    };

    this.successGetPressureSettings = this.successGetPressureSettings.bind(this);
    this.successHandleClickAdvSetup = this.successHandleClickAdvSetup.bind(this);
    this.successUpdateAdvSetupList = this.successUpdateAdvSetupList.bind(this);
    this.successDeleteAdvSetup = this.successDeleteAdvSetup.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
    this.props.dispatch(setupActions.updateAdvSetupList(true));
    this.props.dispatch(setupActions.updateActiveMenu(APPDATA.ADVANCED_SETUP_EXPLORER));
    // reset advSetup selected to undefined
    // this.props.dispatch(setupActions.advSetupSelected(undefined))
    const param = {};
    const passingValue = {};
    Get(APPDATA.API.GET_RETURN_VALVE_PRESSURE_SETTINGS, param, this.successGetPressureSettings, passingValue);
    if (this.props.advSetupSelected === undefined) this.setTopMenuProperties(true);
    else if (this.props.isPCRunning === true) this.setTopMenuProperties(true);
    else this.setTopMenuProperties(false);
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.updateAdvSetupList(nextProps);
    this.resetPreview(nextProps);
    if (nextProps.advSetupSelected === undefined) this.setTopMenuProperties(true);
    else if (nextProps.isPCRunning === true) this.setTopMenuProperties(true);
    else this.setTopMenuProperties(false);
  }

  successGetPressureSettings = (response) => {
    // ConsoleLog("Response Get Pressure Settings", response);
    this.props.dispatch(setupActions.updateDefaultReturnValvePressureParams(response.data));
  };

  resetPreview(nextProps) {
    if (nextProps.resetPreviewAdvSetup) {
      this.props.dispatch(setupActions.resetPreviewAdvSetup(false));

      this.props.dispatch(setupActions.setAdvSetupSelected(undefined));
      this.props.dispatch(setupActions.advSetupSettingExplorer(null));
    }
  }

  initialShowAdvSetup(_advSetupList = [], advSetupSelected1 = null) {
    const {advSetupSelected} = this.props;
    const advSetupList = createNewJsonObject(_advSetupList);

    const newAdvSetupShow = [];
    for (let i = 0; i < advSetupList.length; i++) {
      newAdvSetupShow[i] = advSetupList[i];
      if (advSetupSelected1 && parseInt(newAdvSetupShow[i][APPDATA.KEY.Id], 10) === advSetupSelected1[APPDATA.KEY.Id]) {
        newAdvSetupShow[i].Active = true;
      } else {
        newAdvSetupShow[i].Active = false;
      }
    }
    this.props.dispatch(setupActions.setLastAdvSetupIdView()); // i
    this.props.dispatch(setupActions.updateShowAdvSetup(newAdvSetupShow));

    if (advSetupSelected) {
      this.setState({
        advSetupName: advSetupSelected[APPDATA.KEY.Name],
      });
      this.props.dispatch(setupActions.setAdvSetupSelected(advSetupSelected));
    }
  }

  successUpdateAdvSetupList(response, passingVariable) {
    const advSetupList = createNewJsonObject(response.data.data);
    if (advSetupList === undefined) return;
    this.props.dispatch(setupActions.setAdvSetupList(advSetupList));
    this.props.dispatch(setupActions.setLastAdvSetupIdCreated(advSetupList.length));
    this.initialShowAdvSetup(advSetupList, passingVariable.advSetupSelected);

    const param = {};
    const advSelectedID = this.props.advSetupSelected === undefined ? 0 : this.props.advSetupSelected.Id;
    Get(`${APPDATA.API.API_ADV_SETUP}/${advSelectedID}`, param, this.successHandleClickAdvSetup, advSetupList);
  }

  updateAdvSetupList(nextProps) {
    if (nextProps.updateAdvSetupList) {
      this.props.dispatch(setupActions.updateAdvSetupList(false));
      const param = {};
      const passingVariable = {
        advSetupSelected: this.props.advSetupSelected,
        lastAdvSetupIdView: this.props.lastAdvSetupIdView,
      };
      Get(APPDATA.API.GET_ADV_SETUP_LIST, param, this.successUpdateAdvSetupList, passingVariable);
    }
    if (this.props.modeHelp !== nextProps.modeHelp) {
      // ConsoleLog("Auto profile top menu - modeHelp")
      let content;
      switch (nextProps.modeHelp) {
        case APPDATA.HOME_HELP:
          content = DataHelpHome;
          break;
        case APPDATA.CONCENTRATE_HELP:
          content = DataHelpConcentrate;
          break;
        case APPDATA.CONCENTRATE50ML_HELP:
          content = DataHelpConcentrateMoreThan50;
          break;
        case APPDATA.BUFFER_DISCRETE_HELP:
          content = DataHelpBufferDiscrete;
          break;
        case APPDATA.BUFFER_CONTINOUS_HELP:
          content = DataHelpBufferContinuous;
          break;
        case APPDATA.ADVANCED_SETUP_HELP:
          content = DataHelpAdvancedSetup;
          break;
        case APPDATA.MANUAL_CONTROL_HELP:
          content = DataHelpManualControl;
          break;
        case APPDATA.STATUS_GRAPH_HELP:
          content = DataHelpStatusAndGraph;
          break;
        case APPDATA.RECOVERY_HELP:
          content = DataHelpRecovery;
          break;
        default:
          content = DataHelpHome;
          break;
      }
      this.setState(
        {
          contentHelp: content,
        },
        () => {
          // ConsoleLog(this.state.contentHelp);
          // this.setupTopMenuProperties(!nextProps.isCompleteFill, nextProps.lockAccess, nextProps.ManualControlState);
        },
      );
    }
  }

  setTopMenuProperties = (disableMainButton) => {
    const topButtonProperties = {
      id: APPDATA.LOAD_SETUP,
      label: APPDATA.LOAD_SETUP,
      onClick: this.onClickTopMenu,
      disabled: disableMainButton,
    };
    const backButtonProperties = {
      id: APPDATA.BACK,
      label: '',
      disabled: false,
      onClick: this.onClickTopMenu,
    };
    const secondaryButton = {
      id: 'AutoProfileHelp',
      onClick: this.onClickTopMenu,
      className: 'help-icon',
      icon: HelpIcon,
      disabled: false,
    };
    const titleMenuProperties = APPDATA.ADVANCED_SETUP_EXPLORER;
    this.setupTopMenuProperties(topButtonProperties, backButtonProperties, titleMenuProperties, secondaryButton);
  };

  onClickTopMenu = (e) => {
    switch (e.currentTarget.id) {
      case APPDATA.LOAD_SETUP:
        this.loadAdvSetup();
        break;
      case APPDATA.BACK:
        this.setTopMenuProperties(false);
        this.props.dispatch(setupActions.setEditAdvSetup(false), () => {
          // ConsoleLog("this.props.edit : " + this.props.editAdvSetup);
        });
        // this.goToSetupPage()
        this.goToAutoProfilePage();
        break;
      case 'AutoProfileHelp':
        this.onClickHelp();
        break;
      default:
        break;
    }
  };

  setupTopMenuProperties = (
    topButtonProperties,
    backButtonProperties,
    titleMenuProperties,
    topButtonSecondaryButtonProperties,
  ) => {
    this.props.dispatch(
      setupActions.setTopMenuProperties({
        topButtonProperties:
          topButtonProperties === undefined
            ? undefined
            : {
                id: topButtonProperties.id,
                label: topButtonProperties.label,
                disabled: topButtonProperties.disabled,
                onClick: topButtonProperties.onClick,
              },
        backButtonProperties:
          backButtonProperties === undefined
            ? undefined
            : {
                id: backButtonProperties.id,
                label: backButtonProperties.label,
                disabled: backButtonProperties.disabled,
                onClick: backButtonProperties.onClick,
              },
        titleMenuProperties,
        topButtonSecondaryButtonProperties,
      }),
    );
    this.props.dispatch(setupActions.topButtonTertiaryProperties(undefined));
  };

  // eslint-disable-next-line class-methods-use-this
  goToSetupPage() {
    window.location.href = APPDATA.ADVANCE_SETUP_GENERAL_SETUP;
  }

  // eslint-disable-next-line class-methods-use-this
  goToAutoProfilePage() {
    window.location.href = APPDATA.AUTO_PROFILE_SETUP;
  }

  static IsSelectedAdvSetupRunning(selectedAdvSetup, advSetupChoosen) {
    if (advSetupChoosen === null || advSetupChoosen === undefined) return false;

    if (selectedAdvSetup[APPDATA.KEY.Id] === advSetupChoosen[APPDATA.KEY.Id]) {
      return true;
    }
    return false;
  }

  // eslint-disable-next-line class-methods-use-this
  getLastAdvSetupIdView(advSetupSelected, _advSetupList) {
    const advSetupSelectedId = advSetupSelected[APPDATA.KEY.Id];
    let showAdvSetupLastId;
    let thresholdIdLow = 0;
    const advSetupList = createNewJsonObject(_advSetupList);
    let thresholdIdHight =
      advSetupList.length <= APPDATA.MAX_ADV_SETUP_VIEW ? advSetupList.length : APPDATA.MAX_ADV_SETUP_VIEW;
    for (let i = 0; i < advSetupList.length; i++) {
      if (i >= thresholdIdHight) {
        thresholdIdLow = thresholdIdHight;
        const calculateThresholdHight =
          thresholdIdHight + APPDATA.MAX_ADV_SETUP_VIEW >= advSetupList.length
            ? advSetupList.length
            : thresholdIdLow + APPDATA.MAX_ADV_SETUP_VIEW;
        thresholdIdHight = calculateThresholdHight;
      }

      if (advSetupList[i][APPDATA.KEY.Id] === advSetupSelectedId) {
        showAdvSetupLastId = thresholdIdHight;
        break;
      }
    }
    return showAdvSetupLastId;
  }

  handleClickSetup(e) {
    const address = e.currentTarget.id;

    if (address) {
      // ConsoleLog("handleClickSetup");
      // ConsoleLog(address);
      const param = {};
      const passingVariable = {};
      Get(APPDATA.APP_ROOT + address, param, this.successHandleClickAdvSetup, passingVariable);
    }
  }

  successHandleClickAdvSetup(response, passingValue) {
    const {showAdvSetup, advSetupList, defaultReturnValvePressure, membraneType} = this.props;
    const usedAdvSetup = !showAdvSetup ? passingValue : createNewJsonObject(showAdvSetup);
    const advSetupSelected = response.data;

    const advSetupSelectedId = advSetupSelected[APPDATA.KEY.Id].toString();
    const advSetupName = advSetupSelected[APPDATA.KEY.Name];

    this.setState({
      advSetupName,
    });

    const newAdvSetupShow = usedAdvSetup.map((advSetup) => {
      if (advSetup) {
        return {
          ...advSetup,
          Active: this.isActiveAdvSetup(advSetup[APPDATA.KEY.Id], advSetupSelectedId),
        };
      }
      return null;
    });

    let DefaultReturnValvePressure;
    const returnValvePressure = {
      [MEMBRANE_CUT_OFF.CHIP_3_KDA]: '',
      [MEMBRANE_CUT_OFF.CHIP_5_KDA]: '',
      [MEMBRANE_CUT_OFF.CHIP_10_KDA]: '20',
      [MEMBRANE_CUT_OFF.CHIP_30_KDA]: '15',
      [MEMBRANE_CUT_OFF.CHIP_50_KDA]: '10',
      [MEMBRANE_CUT_OFF.CHIP_100_KDA]: '',
      [MEMBRANE_CUT_OFF.CHIP_300_KDA]: '',
    };

    if (advSetupSelected !== undefined) {
      if (membraneTypeConverter(membraneType) === MembraneTypeOptions.MPES) {
        DefaultReturnValvePressure =
          advSetupSelected[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.MainAdvSetup] !== undefined
            ? advSetupSelected[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.MainAdvSetup][
                APPDATA.KEY.MPESReturnValvePressure
              ]
            : undefined;
      } else {
        DefaultReturnValvePressure =
          advSetupSelected[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.MainAdvSetup] !== undefined
            ? advSetupSelected[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.MainAdvSetup][
                APPDATA.KEY.DefaultReturnValvePressure
              ]
            : undefined;
      }

      if (DefaultReturnValvePressure === null)
        DefaultReturnValvePressure = defaultReturnValvePressure.RCMembraneReturnValvePressure;
      if (DefaultReturnValvePressure !== undefined) {
        DefaultReturnValvePressure.forEach((value) => {
          switch (value[APPDATA.KEY.MembraneCutOffSize]) {
            case MEMBRANE_CUT_OFF.CHIP_3_KDA.toString():
              returnValvePressure[MEMBRANE_CUT_OFF.CHIP_3_KDA] = value[APPDATA.KEY.ReturnValvePressure];
              break;
            case MEMBRANE_CUT_OFF.CHIP_5_KDA.toString():
              returnValvePressure[MEMBRANE_CUT_OFF.CHIP_5_KDA] = value[APPDATA.KEY.ReturnValvePressure];
              break;
            case MEMBRANE_CUT_OFF.CHIP_10_KDA.toString():
              returnValvePressure[MEMBRANE_CUT_OFF.CHIP_10_KDA] = value[APPDATA.KEY.ReturnValvePressure];
              break;
            case MEMBRANE_CUT_OFF.CHIP_30_KDA.toString():
              returnValvePressure[MEMBRANE_CUT_OFF.CHIP_30_KDA] = value[APPDATA.KEY.ReturnValvePressure];
              break;
            case MEMBRANE_CUT_OFF.CHIP_50_KDA.toString():
              returnValvePressure[MEMBRANE_CUT_OFF.CHIP_50_KDA] = value[APPDATA.KEY.ReturnValvePressure];
              break;
            case MEMBRANE_CUT_OFF.CHIP_100_KDA.toString():
              returnValvePressure[MEMBRANE_CUT_OFF.CHIP_100_KDA] = value[APPDATA.KEY.ReturnValvePressure];
              break;
            case MEMBRANE_CUT_OFF.CHIP_300_KDA.toString():
              returnValvePressure[MEMBRANE_CUT_OFF.CHIP_300_KDA] = value[APPDATA.KEY.ReturnValvePressure];
              break;
            default:
              break;
          }
        });
      }
    }
    this.setState(
      {
        ReturnValvePressure: returnValvePressure,
      },
      () => {
        // ConsoleLog("ReturnValvePressure ", this.state.ReturnValvePressure);
      },
    );
    this.props.dispatch(
      setupActions.modifyAdvSetup(
        AdvancedSetupExplorer.IsSelectedAdvSetupRunning(advSetupSelected, this.props.advSetupChoosen),
      ),
    );
    this.props.dispatch(setupActions.updateShowAdvSetup(newAdvSetupShow));
    this.props.dispatch(setupActions.setAdvSetupSelected(advSetupSelected));
    if (this.props.isPCRunning === false && this._isMounted) this.setTopMenuProperties(false);
    if (this.state.searchText !== undefined) {
      this.props.dispatch(
        setupActions.setLastAdvSetupIdView(this.getLastAdvSetupIdView(advSetupSelected, advSetupList)),
      );
    }
  }

  // eslint-disable-next-line class-methods-use-this
  isActiveAdvSetup(advSetupIdOrigin, advSetupIdSelected) {
    if (advSetupIdOrigin === advSetupIdSelected) return true;
    return false;
  }

  // eslint-disable-next-line class-methods-use-this
  thereIsActiveAdvSetup(searchAdvSetupList) {
    for (let i = 0; i < searchAdvSetupList.length; i++) {
      if (searchAdvSetupList[i].Active) return true;
    }
    return false;
  }

  onChange = (e) => {
    switch (e.type) {
      case APPDATA.SEARCH_ADV_SETUP_NAME: {
        const {advSetupList, advSetupSelected} = this.props;

        const searchText = e.value;
        const searchAdvSetupList = searchText
          ? [...advSetupList].filter(createFilter(searchText, KEYS_TO_FILTERS))
          : [];
        this.setState({
          searchText,
          // eslint-disable-next-line react/no-unused-state
          searchAdvSetupList,
        });
        if (!searchText) {
          this.props.dispatch(setupActions.updateActiveMenu(APPDATA.ADVANCED_SETUP_EXPLORER));
          // show advSetup from beginig
          // show all advSetup when searchText is undefined
          this.initialShowAdvSetup(advSetupList, advSetupSelected);
        } else {
          if (!this.thereIsActiveAdvSetup(searchAdvSetupList)) {
            this.props.dispatch(setupActions.resetPreviewAdvSetup(true));
          }
          this.initialShowAdvSetup(searchAdvSetupList, advSetupSelected);
          this.props.dispatch(setupActions.updateActiveMenu(APPDATA.SEARCH_RESULT));
        }

        break;
      }
      default:
        break;
    }
  };

  // to check in search mode or not
  isSearchMode() {
    return this.props.activeMenu === APPDATA.SEARCH_RESULT;
  }

  onClick = (e) => {
    switch (e.currentTarget.id) {
      case EDIT_ADV_SETUP:
        this.actionEditAdvSetup();
        break;
      case DELETE_ADV_SETUP:
        this.actionDeleteAdvSetup();
        break;
      case SEARCH_ADV_SETUP: {
        let keyboardValue = this.state.searchText;
        if (this.props.activeMenu === APPDATA.ADVANCED_SETUP_EXPLORER) keyboardValue = undefined;
        this.props.dispatch(
          showKeyboard({
            keyboardValue,
            keyboardTitle: APPDATA.SEARCH_ADV_SETUP_NAME,
            keyboardPlaceholder: 'Search advSetup',
            keyboardCallBack: this.onChange,
            max: 100,
          }),
        );
        break;
      }
      default:
        break;
    }
  };

  // ------------------- EDIT ADV SETUP -----------------------------------
  actionEditAdvSetup() {
    const {advSetupSelected} = this.props;
    if (advSetupSelected === undefined) {
      this.props.dispatch(
        setupActions.showAlert({
          alertShow: true,
          alertText: 'Please Select a AdvSetup',
          alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
        }),
      );
    } else {
      // ConsoleLog("actionEditAdvSetup");
      this.props.dispatch(
        setupActions.updateAdvSetupName({
          advSetupName: advSetupSelected[APPDATA.KEY.Name],
          advSetupAddress: APPDATA.API.PUT_EDIT_ADV_SETUP,
        }),
      );
      this.EditAdvSetup();
    }
  }

  EditAdvSetup() {
    const {advSetupSelected} = this.props;
    if (advSetupSelected === undefined) {
      this.props.dispatch(
        setupActions.showAlert({
          alertShow: true,
          alertText: 'Please Select a AdvSetup',
          alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
        }),
      );
    } else {
      this.props.dispatch(setupActions.setEditAdvSetup(true));
      // this.props.dispatch(setupActions.updateCurrentAdvSetupParam(advSetupSelected));
      this.goToSetupPage();
    }
  }

  loadAdvSetup() {
    const {advSetupSelected} = this.props;

    if (advSetupSelected === undefined) {
      this.props.dispatch(
        setupActions.showAlert({
          alertShow: true,
          alertText: 'Please Select a AdvSetup',
          alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
        }),
      );
      return;
    }

    this.props.dispatch(setupActions.setEditAdvSetup(false));
    this.props.dispatch(setupActions.updateCurrentAdvSetupParam(advSetupSelected));
    // this.props.dispatch(setupActions.advSetupSelected(advSetupSelected));
    // this.goToSetupPage();
    this.goToAutoProfilePage();
  }

  // ------------------- END EDIT ADV SETUP -----------------------------------
  // ------------------- ADD ADV SETUP -----------------------------------

  // ------------------- DELETE ADV SETUP --------------------------------
  actionDeleteAdvSetup() {
    const {advSetupSelected, advSetupList, advSetupName} = this.props;
    if (advSetupSelected === undefined) {
      this.props.dispatch(
        setupActions.showAlert({
          alertShow: true,
          alertText: 'Please Select a AdvSetup',
          alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
        }),
      );
    } else {
      const advSetupNameSelected = advSetupSelected[APPDATA.KEY.Name];
      if (advSetupList.length > 1) {
        if (advSetupNameSelected === advSetupName) {
          this.props.dispatch(
            setupActions.showAlert({
              alertShow: true,
              alertText: APPDATA.DELETE_RECENT_ADV_SETUP_MESSAGE.replace('ADVSETUPNAME', advSetupNameSelected),
              alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
            }),
          );
          return;
        }
      }
      const popUpButton = [
        {
          id: APPDATA.YES,
          isPrimaryButton: true,
          onClick: this.onClickPopUpDelete,
          label: APPDATA.YES,
        },
        {
          id: APPDATA.NO,
          isPrimaryButton: false,
          onClick: this.onClickPopUpDelete,
          label: APPDATA.NO,
        },
      ];
      this.props.dispatch(
        showPopUp({
          popUpTitle: APPDATA.DELETE_ADV_SETUP,
          popUpQuestion: APPDATA.MESSAGES.ADV_SETUP.DELETE_ADV_SETUP.replace('<advSetup name>', advSetupNameSelected),
          popUpButton,
        }),
      );
    }
  }

  onClickPopUpDelete(e) {
    this.closePopUp();
    switch (e.currentTarget.id) {
      case APPDATA.YES:
        this.deleteAdvSetup();
        break;
      case APPDATA.NO:
        break;
      default:
        break;
    }
  }

  // FIX ME :
  // There is an issue when delete a advSetup in search mode
  // It's because when search not using searchAdvSetupList, and still use lastAdvSetupIdView.
  // lastAdvSetupId should change with lastAdvSetupId searchAdvSetupList
  successDeleteAdvSetup(response, passingValue) {
    const {newShowAdvSetup} = passingValue;
    const newAdvSetupList = passingValue.advSetupList;
    const {lastAdvSetupIdView} = passingValue;
    const {deleteID} = passingValue;
    // eslint-disable-next-line no-restricted-syntax
    for (const i in newShowAdvSetup) {
      if (newShowAdvSetup[i].Id === deleteID) {
        // eslint-disable-next-line block-scoped-var
        newShowAdvSetup.splice(i, 1);
        break;
      }
    }
    // to handle last id delete,
    // show all previouse advSetup
    if (IsEmpty(newShowAdvSetup)) {
      const newLastAdvSetupIdView = lastAdvSetupIdView - 1;
      let firstIndexView = newLastAdvSetupIdView - APPDATA.MAX_ADV_SETUP_VIEW;
      firstIndexView = firstIndexView < 0 ? 0 : firstIndexView;
      this.props.dispatch(setupActions.setLastAdvSetupIdView(newLastAdvSetupIdView));
      for (let i = firstIndexView; i < newLastAdvSetupIdView; i++) {
        newShowAdvSetup.push(newAdvSetupList[i]);
      }
    }
    let j; // remove on list
    // eslint-disable-next-line no-restricted-syntax
    for (j in newAdvSetupList) {
      if (newAdvSetupList[j].Id === deleteID) {
        const isLastAdvSetup =
          newAdvSetupList[lastAdvSetupIdView] !== undefined
            ? newAdvSetupList[lastAdvSetupIdView].Id === deleteID
            : false;
        if (
          lastAdvSetupIdView % APPDATA.MAX_ADV_SETUP_VIEW === 0 &&
          newAdvSetupList.length !== APPDATA.MAX_ADV_SETUP_VIEW &&
          newAdvSetupList[lastAdvSetupIdView] &&
          !isLastAdvSetup
        ) {
          newShowAdvSetup.push(newAdvSetupList[lastAdvSetupIdView]);
        } else {
          this.props.dispatch(setupActions.setLastAdvSetupIdView(newShowAdvSetup.length - 1));
        }
        newAdvSetupList.splice(j, 1);
        break;
      }
    }
    const {defaultConfigAdvSetupParams, currentAdvSetupParams} = this.props;
    if (deleteID === currentAdvSetupParams.Id) {
      const defaultAdvSetup = createNewJsonObject(defaultConfigAdvSetupParams);

      this.props.dispatch(setupActions.updateCurrentAdvSetupParam(defaultAdvSetup));
    }
    this.props.dispatch(setupActions.updateShowAdvSetup(newShowAdvSetup));
    this.props.dispatch(setupActions.setAdvSetupList(newAdvSetupList));
    this.props.dispatch(setupActions.setLastAdvSetupIdCreated(newAdvSetupList.length));
    this.props.dispatch(setupActions.resetPreviewAdvSetup(true));
  }

  deleteAdvSetup() {
    const {advSetupSelected, advSetupList, lastAdvSetupIdView} = this.props;

    const deleteID = advSetupSelected[APPDATA.KEY.Id];
    const param = {};
    const passingValue = {
      newShowAdvSetup: this.props.showAdvSetup.filter((e) => `${e[APPDATA.KEY.Id]}` !== `${deleteID}`),
      advSetupList: advSetupList.filter((e) => `${e[APPDATA.KEY.Id]}` !== `${deleteID}`),
      lastAdvSetupIdView,
      deleteID,
    };
    Delete(`${APPDATA.API.DELETE_ADV_SETUP}/${deleteID}`, param, this.successDeleteAdvSetup, passingValue);
    this.props.dispatch(setupActions.setAdvSetupSelected(undefined));
    this.setTopMenuProperties(true);
  }

  // ------------------- END DELETE ADV SETUP --------------------------------
  closePopUp() {
    this.props.dispatch(hidePopUp());
  }

  // to generate advSetup UI
  generateAdvSetup(advSetup = []) {
    if (!advSetup.length) return null;
    const showAdvSetup = advSetup.map((d) => {
      const isActiveClass = d.Active ? ' activeAdvSetup' : '';
      return (
        <div
          className={`col-md-2 advSetupCollumn ${isActiveClass}`}
          key={d.Links[0].Href}
        >
          <AdvSetup
            onClick={this.handleClickSetup}
            id={d.Links[0].Href}
            label={d.Name.replace(/-/gi, ' ')}
            advSetupNameSelected={this.state.advSetupName}
            active={d.Active}
          />
        </div>
      );
    });

    return showAdvSetup;
  }

  onClickHelp = () => {
    this.setState(
      {
        isHelpModeEnable: true,
      },
      () => {},
    );
  };

  onClosePopUpWizard = () => {
    this.props.dispatch(setupActions.updateMessageAutoProfileHelpParam(APPDATA.HOME_HELP));
    this.setState(
      {
        isHelpModeEnable: false,
        contentHelp: DataHelpHome,
        // onBackToTopButton: false,
      },
      () => {
        // this.setupTopMenuProperties(!this.props.isCompleteFill, this.props.lockAccess, this.props.ManualControlState);
      },
    );
  };

  render() {
    const {ReturnValvePressure} = this.state;
    const {showAdvSetup, advSetupSelected, membraneCutOffSize} = this.props;
    const isSearchResult = this.isSearchMode();
    const style = {
      constraint: {
        fontSize: this.props.fontSize === APPDATA.LARGE_FONT_SIZE ? APPDATA.MEDIUM_FONT_SIZE : this.props.fontSize,
      },
    };
    const advSetupNotFound = (
      <div className="center">
        <AdvSetup
          label="Adv Setup Not Found"
          advSetupNotFound
        />
      </div>
    );
    console.log({showAdvSetup});
    const isNoAdvSetup = !!(showAdvSetup === null || showAdvSetup.length === 0);
    const advSetupNotFoundClass = isNoAdvSetup ? ' center' : '';
    const advSetup = isNoAdvSetup ? advSetupNotFound : this.generateAdvSetup(showAdvSetup);
    const disabledAdvSetupButton = !advSetupSelected; // advSetupSelected ? true : !modifyAdvSetup;
    const disabledAdvSetupButtonDelete =
      !advSetupSelected || (advSetupSelected && advSetupSelected[APPDATA.KEY.Id] === 0);
    // advSetupSelected
    //   ? disabledAdvSetupButton || advSetupSelected[APPDATA.KEY.Id] === 0
    //     ? true
    //     : !modifyAdvSetup
    //   : disabledAdvSetupButton;

    // ConsoleLog("advSetupSelected", advSetupSelected)
    const date =
      advSetupSelected !== undefined
        ? advSetupSelected[APPDATA.KEY.ModifiedAt] === '01/01/0001 00:00:00'
          ? advSetupSelected[APPDATA.KEY.CreatedAt]
          : advSetupSelected[APPDATA.KEY.ModifiedAt]
        : undefined;

    return (
      <div style={style.constraint}>
        <PopUpWizard
          data={this.state.contentHelp}
          fontSize={this.props.fontSize}
          popUpWizardVisible={this.state.isHelpModeEnable}
          onClose={this.onClosePopUpWizard}
        />
        <div className="mainView col-md-7">
          <div className={`row explorerView${advSetupNotFoundClass}`}>
            {/* <TransitionGroup
              transitionName="fade"
              transitionEnter
              transitionLeave={false}
              transitionEnterTimeout={200}
            > */}
            {advSetup}
            {/* </TransitionGroup> */}
          </div>

          <div className="row nav-footer footer col-md-12">
            {!isSearchResult && (
              <div className="col-md-12 center col-search-input">
                <div className="middleAlign">
                  <img
                    className="iconSearchInput"
                    src={SEARCH_ICON_BLACK}
                  />
                </div>
                <input
                  id={SEARCH_ADV_SETUP}
                  onClick={this.onClick}
                  className="searchInput"
                  readOnly
                  placeholder="Search setup..."
                />
              </div>
            )}
            {isSearchResult && (
              <div className="col-md-12 center col-search-input">
                <div className="middleAlign">
                  <img
                    className="iconSearchInput"
                    src={SEARCH_ICON_BLACK}
                  />
                </div>
                <input
                  id={SEARCH_ADV_SETUP}
                  onClick={this.onClick}
                  className="searchInput"
                  readOnly
                  value={this.state.searchText}
                />
              </div>
            )}
          </div>
        </div>
        <div className="sideView col-md-5">
          <div className="row middleAlign">
            <div className="col-md-12 name-date-collumn titleAdvSetup">
              <span className="advSetupName">{advSetupSelected && advSetupSelected[APPDATA.KEY.Name]}</span>
              <br />
            </div>
          </div>
          <div className="row middleAlign dateAdvSetup">
            <div className="col-md-12 name-date-collumn ">
              <span className="advSetupDate">{advSetupSelected && advSetupSelected[APPDATA.KEY.Id] !== 0 && date}</span>
            </div>
          </div>
          <hr className="hrMargin explorerLine" />
          {advSetupSelected && (
            <div className="row middleAlign">
              <div className="col-md-12 name-date-collumn">
                <h3 className="properties-title">Main Cycle Setup</h3>
              </div>
            </div>
          )}
          <div className="row col-md-12 fieldsDiv">
            {advSetupSelected && (
              <>
                <DetailRow
                  label={FIELD_NAME_PRESSURE[2]}
                  value={
                    advSetupSelected &&
                    advSetupSelected[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.MainAdvSetup][
                      APPDATA.KEY.PressureAdvSetup
                    ][2]
                  }
                  unit={APPDATA.UNIT.psi}
                />
                <DetailRow
                  label={FIELD_NAME_PRESSURE[3]}
                  value={
                    advSetupSelected &&
                    (membraneCutOffSize === undefined ? APPDATA.EMPTY_FIELD : ReturnValvePressure[membraneCutOffSize])
                  }
                  unit={APPDATA.UNIT.psi}
                />
                <DetailRow
                  label={APPDATA.FIELD_NAME.DIAPHRAGM_FILL_TIME}
                  value={
                    advSetupSelected &&
                    advSetupSelected[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.MainAdvSetup].DiaphragmTimingOpen
                  }
                  unit={APPDATA.UNIT.ms}
                />
                <DetailRow
                  label={APPDATA.FIELD_NAME.DIAPHRAGM_EMPTY_TIME}
                  value={
                    advSetupSelected &&
                    advSetupSelected[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.MainAdvSetup].DiaphragmTimingClose
                  }
                  unit={APPDATA.UNIT.ms}
                />
              </>
            )}
          </div>

          <div className="row col-md-12 footer edit-delete-row center">
            <div className="col-md-6 center col-delete">
              <button
                type="button"
                id={DELETE_ADV_SETUP}
                className="btn explorerButton delete-button center"
                onClick={this.onClick}
                disabled={disabledAdvSetupButtonDelete}
              >
                <img src={DELETE_ICON} />
                <span style={{width: '100%', justifyContent: 'center', overflow: 'hidden', textOverflow: 'ellipsis'}}>
                  {DELETE_ADV_SETUP}
                </span>
              </button>
            </div>
            <div className="col-md-6 col-edit">
              <button
                type="button"
                id={EDIT_ADV_SETUP}
                className="btn explorerButton edit-button center"
                onClick={this.onClick}
                disabled={disabledAdvSetupButton}
              >
                <img src={EDIT_ICON} />
                <span style={{width: '100%', justifyContent: 'center', overflow: 'hidden', textOverflow: 'ellipsis'}}>
                  {EDIT_ADV_SETUP}
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
function DetailRow(props) {
  const {label, value, unit, disabled} = props;
  const valueParse = parseFloat(value);
  const inputValue = isNaN(valueParse) ? value : valueParse; // .toFixed(decimal)
  // let classInputCollumn = unit === undefined ? "div-2col50 properties-coloumn " : "div-3colInput properties-coloumn "
  const isDisable = disabled === undefined ? false : disabled;
  return (
    <div className="row middleAlign">
      <div className="properties-coloumn">
        <span
          className="spanStyleDetailRowField labelDetailRowField"
          disabled={isDisable}
        >
          {label}
        </span>
        {value === APPDATA.EMPTY_FIELD ? (
          <span
            className="spanStyleDetailRowField"
            disabled={isDisable}
          >
            0
          </span>
        ) : (
          <span
            className="spanStyleDetailRowField"
            disabled={isDisable}
          >
            {inputValue}
          </span>
        )}
        {unit !== undefined && (
          <span
            className="spanStyleDetailRowField unitDetailRowField"
            disabled={isDisable}
          >
            {unit}
          </span>
        )}
      </div>
    </div>
  );
}
export default AdvancedSetupExplorer;
